"use strict";

/**
 * @classdesc
 * Vektorlayer
 *
 * TODO: Feature-Abstrahierung
 *
 * @class
 * @extends gc.gis.layer.GCLayer
 * @memberof gc.gis.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Optionen (siehe auch Optionen in {@link gc.gis.layer.GCLayer})
 * @see {@link gc.gis.layer.GCLayer}
 */
gc.gis.layer.GCVectorLayer = function( options )
{
	var self = this;

	gc.gis.layer.GCLayer.call( this, options );
};
gc.gis.layer.GCVectorLayer.prototype = Object.create( gc.gis.layer.GCLayer.prototype );

/**
 * @override
 * @inheritDoc
 */
gc.gis.layer.GCVectorLayer.prototype.isQueryable = function()
{
    return true;
};
